import { Grid } from '@mantine/core';
import type { AiTokenUsageMetrics } from '@repo/api-codegen';
import { memo, useCallback } from 'react';
import type { AiCostUsageMetricCardType } from '../../types';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export interface MetricsAiCostUsageCardsProps {
	aiTokenUsageMetrics: AiTokenUsageMetrics;
	onMetricCardClick?: (metricType: AiCostUsageMetricCardType) => void;
}

export const MetricsAiCostUsageCards = memo(
	({
		aiTokenUsageMetrics,
		onMetricCardClick,
	}: MetricsAiCostUsageCardsProps) => (
		<Grid py="lg" w="100%" gutter="md">
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Total Requests"
					value={aiTokenUsageMetrics?.total_requests ?? 0}
					onClick={useCallback(
						() => onMetricCardClick?.('Total Requests'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Input Cost"
					value={aiTokenUsageMetrics?.total_input_tokens_cost ?? 0}
					format="currency"
					onClick={useCallback(
						() => onMetricCardClick?.('Input Cost'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Output Cost"
					value={aiTokenUsageMetrics?.total_output_tokens_cost ?? 0}
					format="currency"
					onClick={useCallback(
						() => onMetricCardClick?.('Output Cost'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Cache Write Cost"
					value={
						aiTokenUsageMetrics?.total_cache_creation_input_tokens_cost ?? 0
					}
					format="currency"
					onClick={useCallback(
						() => onMetricCardClick?.('Cache Creation Cost'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Cache Read Cost"
					value={aiTokenUsageMetrics?.total_cache_read_input_tokens_cost ?? 0}
					format="currency"
					onClick={useCallback(
						() => onMetricCardClick?.('Cache Read Cost'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
			<Grid.Col span={4}>
				<MetricsOverviewCard
					title="Total Cost"
					value={aiTokenUsageMetrics?.total_tokens_cost ?? 0}
					format="currency"
					onClick={useCallback(
						() => onMetricCardClick?.('Total Cost'),
						[onMetricCardClick]
					)}
				/>
			</Grid.Col>
		</Grid>
	)
);
